import { ModuleContent } from '../contract';

export type BizAgentModuleContent = {
	configSystemName: string;
};

export function isBizAgentModuleContent(content: ModuleContent): content is BizAgentModuleContent {
	return typeof (content as BizAgentModuleContent).configSystemName === 'string';
}

export function getBizAgentModuleIndexableText(content: ModuleContent): string {
	if (!isBizAgentModuleContent(content)) return '';
	return content.configSystemName.trim();
}
